import { Observable } from "rxjs";
import { retry } from 'rxjs/operators';
import { Injectable, InjectionToken } from "@angular/core";
import { HttpInterface } from "./http.interface";
import { HttpClient, HttpHeaders, HttpParams } from "@angular/common/http";
import { environment } from "environments/environment";

export const KMR_HTTP_SERVICE = new InjectionToken('kmr http service');

/**
 * Same shape as HttpService, but targets KisnaMeriRoshaniAPI's own base URL
 * (environment.kmrApiBaseUrl) instead of POS's own API. The global JwtInterceptor still attaches
 * the POS bearer token to these calls (it is not scoped to a single host), which is what lets
 * KisnaMeriRoshaniAPI validate the same token without a separate KMR login step.
 */
@Injectable()
export class KmrHttpService implements HttpInterface {

  constructor(private _http: HttpClient) {
  }

  getBaseUrl(): string {
    return environment.kmrApiBaseUrl;
  }

  post<T>(url: string, data: any): Observable<T> {
    if (!url) {
      throw "url is empty";
    }
    url = environment.kmrApiBaseUrl.concat(url);
    return this._http.post<T>(url, data, { withCredentials: true }).pipe(retry(2));
  }

  put<T>(url: string, data: any): Observable<T> {
    if (!url) {
      throw "url is empty";
    }
    url = environment.kmrApiBaseUrl.concat(url);
    return this._http.put<T>(url, data, { withCredentials: true }).pipe(retry(2));
  }

  get<T>(url: string, params?: HttpParams, headers?: HttpHeaders): Observable<T> {
    if (!url) {
      throw "url is empty";
    }
    url = environment.kmrApiBaseUrl.concat(url);
    return this._http.get<T>(url, { params: params, headers: headers, withCredentials: true });
  }

  getFile(url: string, params?: HttpParams, headers?: HttpHeaders): Observable<Blob> {
    if (!url) {
      throw "url is empty";
    }
    url = environment.kmrApiBaseUrl.concat(url);
    return this._http.get(url, { params: params, headers: headers, withCredentials: true, responseType: 'blob' }).pipe(retry(2));
  }

  delete<T>(url: string, id: number): Observable<T> {
    if (!url) {
      throw 'url is empty';
    }
    const options = {
      params: { id: id.toString() },
      withCredentials: true
    };
    url = environment.kmrApiBaseUrl.concat(url);
    return this._http.delete<T>(url, options).pipe(retry(2));
  }
}
